import React, { Component } from 'react'
// import './resetPassword.css'
import InputField from '../../components/inputField'
import ApiCall from '../../services/api'

class ResetPassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            login: '',
            email: '',
            phone: '',
            password: '',
            confirm_password: '',
            code: '',
            grant_type: 'password',
            client_id: props.match.params.client_id,
            error: false,
            cod_member:''
        }
    }

    componentWillMount() {
        this.setState({
            client_id: localStorage.getItem('client_id')
        })
    }

    handleChangeInputValue = (event) => {
        const {
            target: {
                name, value
            }
        } = event;

        this.setState({
            [name]: value
        })
    }

    handleLoginUser = (login) => {
        const params = {
            'login': login,
            'password': this.state.password,
            'grant_type': this.state.grant_type,
            'client_id': 12,
        };

        ApiCall('/login', 'POST', params)
            .then(result => {
                if (result.status_code !== 200) {
                    this.setState({ error: true })

                } else {
                    this.setState({ error: false })
                    window.opener.postMessage(result, '*')
                }
            })
    }

    handleUpdateData = () => {
        const params = {
            'des_email': this.state.email,
            'num_celula': this.state.phone,
            'password': this.state.password,
            'code': this.state.code
        };

        ApiCall('/membros/code/' + this.props.match.params.id, 'POST', params)
            .then(result => {
                if (result.status_code !== 200) {
                        this.setState({ error: true })
                } else {

                    if(result.data.cod_cpf != null && result.data.cod_cpf !== ''){

                        this.setState({cod_member: result.data.cod_cpf})

                    }else if(result.data.cod_cgc != null && result.data.cod_cgc !== ''){

                        this.setState({cod_member: result.data.cod_cgc})

                    }else if (result.data.cod_cgc == null && result.data.cod_ojp != null){

                        this.setState({cod_member: result.data.cod_ojp})
                    }

                    this.setState({ error: false, login: this.state.cod_member }, () => { this.handleLoginUser(this.state.cod_member) })

                }
            });
    }

    render() {
        let errorAlert = '';

        if (this.state.error) {
            errorAlert = <div className="alert alert-danger">
                <span>Os dados informados não são válidos. Verifique seu token.</span>
            </div>
        }
        return (
            <div>
                <p>Utilize o token recebido para criar uma nova senha</p>
                {errorAlert}
                <InputField
                    value={this.state.email}
                    name="email"
                    type="email"
                    placeholder="Email"
                    onChange={this.handleChangeInputValue}
                />
                <InputField
                    mask={'(99) 99999-9999'}
                    value={this.state.phone}
                    name="phone"
                    type="text"
                    placeholder="Telefone"
                    onChange={this.handleChangeInputValue}
                />
                <InputField
                    value={this.state.password}
                    name="password"
                    type="password"
                    placeholder="Senha"
                    onChange={this.handleChangeInputValue}
                />
                <InputField
                    value={this.state.confirm_password}
                    name="confirm_password"
                    type="password"
                    placeholder="Confirmar Senha"
                    onChange={this.handleChangeInputValue}
                />
                <InputField
                    value={this.state.code}
                    name="code"
                    type="text"
                    placeholder="Token"
                    onChange={this.handleChangeInputValue}
                />
                <InputField
                    value="Salvar"
                    type="button"
                    className="button-primary"
                    onClick={this.handleUpdateData}
                />
            </div>
        )
    }
}

export default ResetPassword


// WEBPACK FOOTER //
// ./src/Containers/resetPassword/resetPassword.js
